export const css = {
    oneaction: '_2lglO-Le',
    timerblock: '_3cdSPlGN',
    ' _key': 'afcpe-theme/afcpe/quiz-widgets/questionfeedback'
};
export default css;
